import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const MypageDetailRow = ({ label, content, contents }) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.label) }, label),
        React.createElement("div", { className: css(styles.content) }, (contents === null || contents === void 0 ? void 0 : contents.length) ? contents.map((c, i) => React.createElement("div", { key: i }, c)) : content)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        fontSize: 14,
        lineHeight: '140%',
        letterSpacing: 0.56,
        minHeight: 50,
        padding: '15px 0',
    },
    label: {
        fontWeight: 500,
    },
    content: {
        color: Colors.GrayDarkest,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 8,
        flex: 1,
    },
});
